import { defineMessages } from "react-intl";

export const scope = "components.BalanceCard";

export const walletsMessages = defineMessages({
  ars: {
    id: `${scope}.ars`,
    defaultMessage: "Cuenta en pesos",
  },
  usd: {
    id: `${scope}.usd`,
    defaultMessage: "Cuenta en dolares",
  },
  default: {
    id: `${scope}.lastMovements`,
    defaultMessage: "Cuenta en {name}",
  },
  earningTna: {
    id: `${scope}.earningTna`,
    defaultMessage: "Ganando {tna}% TNA",
  },
});
